module.exports = __webpack_public_path__ + "img/8.b086507a.png";